import {useAISidepanelGlobalClientState} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import useIsPhoneWidth from 'ui-library/hooks/useIsPhoneWidth';
import useStoreSelector from 'ui-library/hooks/useStoreSelector';

export default function useIsAIChatOpenInPhone(): boolean {
  const [panelState] = useAISidepanelGlobalClientState();
  const activeChat = panelState.activeChat;
  const isSidepanelExpanded = useStoreSelector(SidepanelStore, (store) => store.getIsExpanded());
  const isPhoneWidth = useIsPhoneWidth();
  return activeChat.id != null && isSidepanelExpanded && isPhoneWidth;
}
